import styled from "styled-components"
import { LazyLoadImage } from "react-lazy-load-image-component"
export const Box = styled.div`
    background-color: ${({ bg }) => bg ? bg : ''};
`
export const IconBoxColor = styled.div`
    svg {
        [stroke] {
            stroke: ${({ iconColor }) => iconColor ? iconColor : ''};
        }
    }
`
export const LazyImage = (props) => {
    return (
        <LazyLoadImage
            {...props}
            effect="blur"
        />
    )
}
export const HeadingStyled = styled.div`
    font-size:${props => props.size ? props.size : '26px'};
    font-weight:${props => props.weight ? props.weight : ''};
    font-family: ${props => props.family ? props.family : "var(--bold)"};
    color:${props => props.color ? props.color : ""};
    line-height: ${props => props.lh ? props.lh : '1'};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    display: ${props => props.display ? props.display : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arBold)"};
    }
`
export const SpanStyled = styled.span`
    display: inline-block;
    font-size:${props => props.size ? props.size : '16px'};
    font-weight:${props => props.weight ? props.weight : ''};
    font-family: ${props => props.family ? props.family : "var(--medium)"};
    color:${props => props.color ? props.color : "var(--textDark)"};
    line-height: ${props => props.lh ? props.lh : ''};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arMedium)"};
    }
`
export const SpanStyledB = styled.span`
    font-size:${props => props.size ? props.size : '16px'};
    font-weight:${props => props.weight ? props.weight : ''};
    font-family: ${props => props.family ? props.family : "var(--bold)"};
    color:${props => props.color ? props.color : "var(--darkGrey)"};
    line-height: ${props => props.lh ? props.lh : ''};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arBold)"};
    }
`
export const MainHeading = styled.div`
display: block;
    font-size:${props => props.size ? props.size : '40px'};
    font-family: ${props => props.family ? props.family : "var(--semiBold)"};
    color:${props => props.color ? props.color : "var(--textDark)"};
    line-height: ${props => props.lh ? props.lh : '1.3'};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    /* -webkit-text-stroke: 2px black; */
    body.rtl &{
        font-family: var(--arSemiBold);
        font-size: 35px;
        &.main-heading-sub{
            font-size: 32px;
        }
        line-height: 1.5;
    }
    @media (max-width: 767px) {
        body.rtl &{
            font-size: 28px;
        }
    }
    @media (max-width: 575px) {
        font-size: 32px;
        &.main-heading-sub{
            font-size: 25px;
        }
        body.rtl &{
            font-size: 28px;
        }
    }
`
export const InnerHeading = styled.div`
    font-size:${props => props.size ? props.size : '32px'};
    font-family: ${props => props.family ? props.family : "var(--bold)"};
    color:${props => props.color ? props.color : "var(--secondaryColor)"};
    line-height: ${props => props.lh ? props.lh : '1'};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    /* -webkit-text-stroke: 2px black; */
    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arBold)"};
    }
`
export const TextStyledSem = styled.div`
    font-size:${props => props.size ? props.size : '20px'};
    font-family: ${props => props.family ? props.family : "var(--semiBold)"};
    color:${props => props.color ? props.color : "var(--white)"};
    line-height: ${props => props.lh ? props.lh : '1'};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arSemiBold)"};
    }
`
export const TextStyled = styled.p`
    font-size:${props => props.size ? props.size : '15px'};
    font-weight:${props => props.weight ? props.weight : 'normal'};
    font-family: ${props => props.family ? props.family : "var(--regular)"};
    color:${props => props.color ? props.color : "var(--darkGrey)"};
    line-height: ${props => props.lh ? props.lh : ''};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arRegular)"};
    }
`
export const LabelStyled = styled.label`
    font-size:${props => props.size ? props.size : '16px'};
    font-family: ${props => props.family ? props.family : "var(--medium)"};
    color:${props => props.color ? props.color : 'var(--white)'};
    line-height:${props => props.lh ? props.lh : 'normal'};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    margin-bottom: 2px;
    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arRegular)"};
    }
`
export const ButtonStyled = styled.button`
    font-size:${props => props.size ? props.size : '16px'};
    font-weight:${props => props.weight ? props.weight : '500'};
    font-family:${props => props.direction === 'ltr' && props.family ? props.family : "var(--medium)"};
    background-color:${props => props.bg ? props.bg : "none"};
    color: ${props => props.color ? props.color : "var(--ThemeColor)"};
    padding: ${props => props.padding ? props.padding : "11px 20px"};
    border: ${props => props.border ? props.border : "none"};
    width: ${props => props.width ? props.width : "100%"};
    line-height: ${props => props.lineHeight ? props.lineHeight : "normal"};
    border-radius: ${props => props.radius ? props.radius : "8px"};
    transition: 0.3s ease-in-out opacity;
    letter-spacing: 0.8px;
    &:hover {
        opacity: 0.8;
    }
`
export const CardStyled = styled.div`
    box-shadow: 0px 5px 4px rgba(0, 0, 0, 0.03);
    border-radius: 15px;
    background-color:${props => props.bg ? props.bg : "var(--white)"};
    .card-styled-header {
        padding: 16px;
        border-bottom: 1px solid var(--grey-light);
        margin-bottom: 16px;
    }
`

export const DurationToggleContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1.5rem 0;
`;

export const DurationToggle = styled.div`
  display: flex;
  border-radius: 50px;
  background-color: var(--themeColor);
  padding: 5px;
  width: fit-content;
`;

export const DurationOption = styled.button`
  background-color: ${({ active }) => (active ? "white" : "var(--themeColor)")};
  color: ${({ active }) => (active ? "var(--themeColor)" : "white")};
  font-weight: 600;
  padding: 10px 25px;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: 0.3s ease;
  font-size: 16px;
  font-family: var(--medium);

  &:hover {
    opacity: 0.85;
  }
  body.rtl &{
    font-family: var(--arMedium);
  }
`;